<template>
  <el-dialog
      :title="$t('posts.edit.changeMassUsersTitle')"
      :visible="visible"
      width="30%"
      v-loading="loading"
      @close="$emit('update:visible', false)"
  >
    <div v-if="selectedIds && selectedIds.length <= maxSelection">
      <el-select
          v-if="users.length > 0"
          clearable
          filterable
          v-model="userSelected"
          style="width: 100%"
          @change="onUserChange"
      >
        <el-option
            v-for="user in users"
            :key="user.id"
            :value="user.id"
            :label="user.fullname"
            style="text-transform: capitalize"
        />
      </el-select>
      <span v-else class="text-left"><br>{{ $t('posts.dialog.noUsersFound') }}</span>

      <div v-if="selectedUser" style="margin-top: 12px; color: #606266; font-size: 13px;">
        <div v-if="selectedUser.username">{{ selectedUser.username }}</div>
        <div v-if="selectedUser.identifierCode && selectedUser.identifierValue">
          {{ selectedUser.identifierCode }} : {{ selectedUser.identifierValue }}
        </div>
      </div>
    </div>
    <div v-else>
      {{ $t('posts.dialog.lengthSelectedExceeded', { length: maxSelection }) }}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">{{ $t('posts.dialog.cancel') }}</el-button>
      <el-button
          type="danger"
          :disabled="loading || !userSelected"
          @click="onValidate"
      >
        {{ $t('general.selection.validate') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ElButton from '../../../../components/Button'
import { HTTP_HYPER_ESPACE_BACKEND } from '../../../../services/http-common'
import { getUsers } from '@/services/users'

export default {
  name: 'DialogChangeUserMultiplePosts',
  components: { ElButton },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    selectedIds: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      users: [],
      userSelected: null,
      selectedUser: null,
      loading: false,
      maxSelection: 30
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isSubUser () {
      return this.$store.getters.isSubUser
    },
    currentUser () {
      return this.$store.getters.getUser
    },
    fluxCode () {
      return this.sitimmoUser && this.sitimmoUser.univers === 'VO' ? 'SAISIE_VO' : 'SAISIE_IMMO'
    }
  },
  methods: {
    onUserChange () {
      if (this.userSelected) {
        this.selectedUser = this.users.find(u => u.id === this.userSelected) || null
      } else {
        this.selectedUser = null
      }
    },
    async onValidate () {
      if (!this.userSelected || !this.selectedIds || !this.selectedIds.length) {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        return
      }

      const user = this.users.find(u => u.id === this.userSelected)
      if (!user) {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        return
      }

      const annonce = {
        user_data_code: user.identifierCode,
        user_data_value: user.identifierValue,
        user_data_change: true,
        user_data_id: user.id
      }

      this.loading = true
      try {
        const annonceurId = this.sitimmoUser.id || this.sitimmoUser.annonceur || this.sitimmoUser.advertiser
        const response = await HTTP_HYPER_ESPACE_BACKEND.post('/annonce/batch-update', {
          ids: this.selectedIds,
          fluxCode: this.fluxCode,
          annonceurId,
          annonce
        })

        if (response.data && response.data.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
        } else {
          this.$message({ message: this.$t('Vos annonces ont bien été mises à jour'), type: 'success' })
          this.$emit('success')
          this.$emit('update:visible', false)
        }
      } catch (e) {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      } finally {
        this.loading = false
        this.userSelected = null
        this.selectedUser = null
      }
    },
    async fetchUsers () {
      const filters = { active: true, pagination: false, roles: '!ROLE_CONTACT' }
      const response = await getUsers(filters)
      if (response && response.list) {
        this.users = response.list
      }
    }
  },
  mounted () {
    this.fetchUsers()
  }
}
</script>
